/*
 * @Author: Json Chen
 * @Date: 2022-06-14 16:53:39
 * @LastEditTime: 2022-06-14 17:47:16
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/Components/hooks/permission.tsx
 */
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';

export const legalPermissions = (uuid: string) => {
  const view_legal_page_details = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelLegal,
        subCategory: EnumSubCategory.ChannelLegal,
        operation: EnumOperation.view_legal_page_details,
        uuid,
      }),
    ],
  });
  const add_edit_legal_page = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelLegal,
        subCategory: EnumSubCategory.ChannelLegal,
        operation: EnumOperation.add_edit_legal_page,
        uuid,
      }),
    ],
  });
  const archive_legal_page = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelLegal,
        subCategory: EnumSubCategory.ChannelLegal,
        operation: EnumOperation.archive_legal_page,
        uuid,
      }),
    ],
  });
  return {
    canView: view_legal_page_details,
    canEdit: add_edit_legal_page,
    canDelete: archive_legal_page,
  };
};

export const tacPermissions = (uuid: string) => {
  const view_T_C_details_page = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelLegal,
        subCategory: EnumSubCategory.ChannelLegal,
        operation: EnumOperation.view_T_C_details_page,
        uuid,
      }),
    ],
  });
  const add_edit_T_C = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelLegal,
        subCategory: EnumSubCategory.ChannelLegal,
        operation: EnumOperation.add_edit_T_C,
        uuid,
      }),
    ],
  });
  const archive_T_C = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelLegal,
        subCategory: EnumSubCategory.ChannelLegal,
        operation: EnumOperation.archive_T_C,
        uuid,
      }),
    ],
  });

  return {
    canView: view_T_C_details_page,
    canEdit: add_edit_T_C,
    canDelete: archive_T_C,
  };
};
